import { Link } from "react-router-dom";

interface ComingSoonPageProps {
  feature: string;
  pr: string;
  description?: string;
  backTo?: string;
  backLabel?: string;
}

/**
 * Generic "coming-soon" placeholder for routes whose implementation lands
 * in a later PR. Originally introduced by the deal flow with a
 * back-link to the Deal Pipeline hardcoded; Portfolio Administration v1.0
 * PR 0 generalized it so per-module placeholders can supply their own
 * description and back-link target.
 */
export function ComingSoonPage({
  feature,
  pr,
  description,
  backTo = "/",
  backLabel = "Back to Dashboard",
}: ComingSoonPageProps) {
  return (
    <div className="flex flex-col items-center justify-center gap-space-3 py-space-8">
      <div className="max-w-md rounded-lg border border-border bg-white-pure p-space-6 text-center shadow-sm">
        <h1 className="text-headline-2 font-display font-semibold text-onyx">{feature}</h1>
        <p className="mt-space-2 text-body text-onyx/70">Coming soon in {pr}.</p>
        {description && (
          <p className="mt-space-4 text-small text-onyx/60">{description}</p>
        )}
        <Link
          to={backTo}
          className="mt-space-4 inline-flex items-center gap-space-2 text-small font-display font-semibold text-gold hover:text-gold-shadow"
        >
          {backLabel}
        </Link>
      </div>
    </div>
  );
}
